export default __webpack_public_path__ + "static/media/nanfang.ddb9e020.png";